import { BaseUser, Role } from '@core/model/user.model';

export interface LoggedUser extends BaseUser {
  readonly fullName?: string;
  readonly role: LoggedUserRole;
  readonly originalRole?: Role;
}

export interface LoggedUserRole {
  name: Role;
  permissions: UserPermission[];
}

export interface UserPermission {
  readonly name: string;
}

export enum Permissions {
  // ADMIN
  canManageDocuments = 'canManageDocuments',
  canManageOwnDocuments = 'canManageOwnDocuments',
  canCompileDocuments = 'canCompileDocuments',
  canUnlockDocuments = 'canUnlockDocuments',
  canManageUsers = 'canManageUsers',
  canManageCompanies = 'canManageCompanies',
  canManagePipelines = 'canManagePipelines',
  canManageJobs = 'canManageJobs',
  canManageSelf = 'canManageSelf',
  canManageParameters = 'canManageParameters',
  canDowngradeRole = 'canDowngradeRole',
  canRestoreRole = 'canRestoreRole',
  canSeeHiddenPipelines = 'canSeeHiddenPipelines',
  canManageNamespaces = 'canManageNamespaces',
  canManageTags = 'canManageTags',
  canUseAiAssistant = 'canUseAiAssistant',
  canUploadFiles = 'canUploadFiles',
  canUseAiGeneration = 'canUseAiGeneration',

  // OPERATOR
  canLockDocuments = 'canLockDocuments',
}
